import { createFileRoute } from '@tanstack/react-router';

import { UserDetailPage } from '@/pages/users/user-detail-page';

export const Route = createFileRoute('/users/$id')({
  component: UserDetail,
});

function UserDetail() {
  const { id } = Route.useParams();
  return <UserDetailPage id={id} />;
}
